// tslint:disable
/**
 * Learning request API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as globalImportUrl from 'url';
import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';

import { Preset } from '../models';
import { PresetCreate } from '../models';
import { StatusEdit } from '../models';
import { StatusProfile } from '../models';
import { StatusProfileCreate } from '../models';
import { StatusProfileEdit } from '../models';
/**
 * StatusProfileApi - axios parameter creator
 * @export
 */
export const StatusProfileApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {StatusProfileCreate} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createProfile(body: StatusProfileCreate, options: any = {}): RequestArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling createProfile.');
            }
            const localVarPath = `/learning-requests/profiles`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {StatusEdit} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createStatus(id: string, body: StatusEdit, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling createStatus.');
            }
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling createStatus.');
            }
            const localVarPath = `/learning-requests/profile/{id}/statuses`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteProfile(id: string, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling deleteProfile.');
            }
            const localVarPath = `/learning-requests/profile/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {string} statusId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteStatus(id: string, statusId: string, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling deleteStatus.');
            }
            // verify required parameter 'statusId' is not null or undefined
            if (statusId === null || statusId === undefined) {
                throw new RequiredError('statusId','Required parameter statusId was null or undefined when calling deleteStatus.');
            }
            const localVarPath = `/learning-requests/profile/{id}/status/{statusId}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"statusId"}}`, encodeURIComponent(String(statusId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {StatusProfileEdit} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editProfile(id: string, body: StatusProfileEdit, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling editProfile.');
            }
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling editProfile.');
            }
            const localVarPath = `/learning-requests/profile/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {string} statusId 
         * @param {StatusEdit} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editStatus(id: string, statusId: string, body: StatusEdit, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling editStatus.');
            }
            // verify required parameter 'statusId' is not null or undefined
            if (statusId === null || statusId === undefined) {
                throw new RequiredError('statusId','Required parameter statusId was null or undefined when calling editStatus.');
            }
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling editStatus.');
            }
            const localVarPath = `/learning-requests/profile/{id}/status/{statusId}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"statusId"}}`, encodeURIComponent(String(statusId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProfile(id: string, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling getProfile.');
            }
            const localVarPath = `/learning-requests/profile/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} companyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listProfiles(companyId: string, options: any = {}): RequestArgs {
            // verify required parameter 'companyId' is not null or undefined
            if (companyId === null || companyId === undefined) {
                throw new RequiredError('companyId','Required parameter companyId was null or undefined when calling listProfiles.');
            }
            const localVarPath = `/learning-requests/profiles`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (companyId !== undefined) {
                localVarQueryParameter['companyId'] = companyId;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {PresetCreate} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        profilePreset(body: PresetCreate, options: any = {}): RequestArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling profilePreset.');
            }
            const localVarPath = `/learning-requests/profile/preset`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        profilesPresetsList(options: any = {}): RequestArgs {
            const localVarPath = `/learning-requests/profiles/presets/list`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {Array<string>} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sortStatuses(id: string, body: Array<string>, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling sortStatuses.');
            }
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling sortStatuses.');
            }
            const localVarPath = `/learning-requests/profile/{id}/statuses/sort`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * StatusProfileApi - functional programming interface
 * @export
 */
export const StatusProfileApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {StatusProfileCreate} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createProfile(body: StatusProfileCreate, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<StatusProfile> {
            const localVarAxiosArgs = StatusProfileApiAxiosParamCreator(configuration).createProfile(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {StatusEdit} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createStatus(id: string, body: StatusEdit, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<StatusProfile> {
            const localVarAxiosArgs = StatusProfileApiAxiosParamCreator(configuration).createStatus(id, body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteProfile(id: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void> {
            const localVarAxiosArgs = StatusProfileApiAxiosParamCreator(configuration).deleteProfile(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {string} statusId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteStatus(id: string, statusId: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<StatusProfile> {
            const localVarAxiosArgs = StatusProfileApiAxiosParamCreator(configuration).deleteStatus(id, statusId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {StatusProfileEdit} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editProfile(id: string, body: StatusProfileEdit, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<StatusProfile> {
            const localVarAxiosArgs = StatusProfileApiAxiosParamCreator(configuration).editProfile(id, body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {string} statusId 
         * @param {StatusEdit} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editStatus(id: string, statusId: string, body: StatusEdit, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<StatusProfile> {
            const localVarAxiosArgs = StatusProfileApiAxiosParamCreator(configuration).editStatus(id, statusId, body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProfile(id: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<StatusProfile> {
            const localVarAxiosArgs = StatusProfileApiAxiosParamCreator(configuration).getProfile(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} companyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listProfiles(companyId: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<StatusProfile>> {
            const localVarAxiosArgs = StatusProfileApiAxiosParamCreator(configuration).listProfiles(companyId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {PresetCreate} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        profilePreset(body: PresetCreate, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<StatusProfile> {
            const localVarAxiosArgs = StatusProfileApiAxiosParamCreator(configuration).profilePreset(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        profilesPresetsList(options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Preset>> {
            const localVarAxiosArgs = StatusProfileApiAxiosParamCreator(configuration).profilesPresetsList(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {Array<string>} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sortStatuses(id: string, body: Array<string>, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<StatusProfile> {
            const localVarAxiosArgs = StatusProfileApiAxiosParamCreator(configuration).sortStatuses(id, body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * StatusProfileApi - factory interface
 * @export
 */
export const StatusProfileApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @param {StatusProfileCreate} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createProfile(body: StatusProfileCreate, options?: any) {
            return StatusProfileApiFp(configuration).createProfile(body, options)(axios, basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {StatusEdit} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createStatus(id: string, body: StatusEdit, options?: any) {
            return StatusProfileApiFp(configuration).createStatus(id, body, options)(axios, basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteProfile(id: string, options?: any) {
            return StatusProfileApiFp(configuration).deleteProfile(id, options)(axios, basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {string} statusId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteStatus(id: string, statusId: string, options?: any) {
            return StatusProfileApiFp(configuration).deleteStatus(id, statusId, options)(axios, basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {StatusProfileEdit} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editProfile(id: string, body: StatusProfileEdit, options?: any) {
            return StatusProfileApiFp(configuration).editProfile(id, body, options)(axios, basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {string} statusId 
         * @param {StatusEdit} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editStatus(id: string, statusId: string, body: StatusEdit, options?: any) {
            return StatusProfileApiFp(configuration).editStatus(id, statusId, body, options)(axios, basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProfile(id: string, options?: any) {
            return StatusProfileApiFp(configuration).getProfile(id, options)(axios, basePath);
        },
        /**
         * 
         * @param {string} companyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listProfiles(companyId: string, options?: any) {
            return StatusProfileApiFp(configuration).listProfiles(companyId, options)(axios, basePath);
        },
        /**
         * 
         * @param {PresetCreate} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        profilePreset(body: PresetCreate, options?: any) {
            return StatusProfileApiFp(configuration).profilePreset(body, options)(axios, basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        profilesPresetsList(options?: any) {
            return StatusProfileApiFp(configuration).profilesPresetsList(options)(axios, basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {Array<string>} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sortStatuses(id: string, body: Array<string>, options?: any) {
            return StatusProfileApiFp(configuration).sortStatuses(id, body, options)(axios, basePath);
        },
    };
};

/**
 * StatusProfileApi - object-oriented interface
 * @export
 * @class StatusProfileApi
 * @extends {BaseAPI}
 */
export class StatusProfileApi extends BaseAPI {
    /**
     * 
     * @param {StatusProfileCreate} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StatusProfileApi
     */
    public createProfile(body: StatusProfileCreate, options?: any) {
        return StatusProfileApiFp(this.configuration).createProfile(body, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {string} id 
     * @param {StatusEdit} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StatusProfileApi
     */
    public createStatus(id: string, body: StatusEdit, options?: any) {
        return StatusProfileApiFp(this.configuration).createStatus(id, body, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StatusProfileApi
     */
    public deleteProfile(id: string, options?: any) {
        return StatusProfileApiFp(this.configuration).deleteProfile(id, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {string} id 
     * @param {string} statusId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StatusProfileApi
     */
    public deleteStatus(id: string, statusId: string, options?: any) {
        return StatusProfileApiFp(this.configuration).deleteStatus(id, statusId, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {string} id 
     * @param {StatusProfileEdit} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StatusProfileApi
     */
    public editProfile(id: string, body: StatusProfileEdit, options?: any) {
        return StatusProfileApiFp(this.configuration).editProfile(id, body, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {string} id 
     * @param {string} statusId 
     * @param {StatusEdit} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StatusProfileApi
     */
    public editStatus(id: string, statusId: string, body: StatusEdit, options?: any) {
        return StatusProfileApiFp(this.configuration).editStatus(id, statusId, body, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StatusProfileApi
     */
    public getProfile(id: string, options?: any) {
        return StatusProfileApiFp(this.configuration).getProfile(id, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {string} companyId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StatusProfileApi
     */
    public listProfiles(companyId: string, options?: any) {
        return StatusProfileApiFp(this.configuration).listProfiles(companyId, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {PresetCreate} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StatusProfileApi
     */
    public profilePreset(body: PresetCreate, options?: any) {
        return StatusProfileApiFp(this.configuration).profilePreset(body, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StatusProfileApi
     */
    public profilesPresetsList(options?: any) {
        return StatusProfileApiFp(this.configuration).profilesPresetsList(options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {string} id 
     * @param {Array<string>} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StatusProfileApi
     */
    public sortStatuses(id: string, body: Array<string>, options?: any) {
        return StatusProfileApiFp(this.configuration).sortStatuses(id, body, options)(this.axios, this.basePath);
    }

}
